import { render, staticRenderFns } from "./itc-album-detail.vue?vue&type=template&id=a823f4f2&scoped=true"
import script from "./itc-album-detail.vue?vue&type=script&lang=js"
export * from "./itc-album-detail.vue?vue&type=script&lang=js"
import style0 from "./itc-album-detail.vue?vue&type=style&index=0&id=a823f4f2&prod&lang=scss&scoped=true"
import style1 from "./itc-album-detail.vue?vue&type=style&index=1&id=a823f4f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a823f4f2",
  null
  
)

export default component.exports